<template>
  <div class="wrap">
    <div class="footer-etc">
      <div class="fsite" v-if="!isApp()">
        <select v-model="relateSite" placeholder="관계사이트바로가기" @change="goSite">
          <option value="">관계사이트바로가기</option>
          <option value="http://cert.khff.or.kr/" label="건강기능식품 민간 자격증">건강기능식품 민간 자격증</option>
          <option value="http://www.khsa.or.kr/" label="한국건강기능식품협회">한국건강기능식품협회</option>
          <option value="http://www.khsi.re.kr/" label="한국기능식품연구원">한국기능식품연구원</option>
          <option value="http://ad.khsa.or.kr/" label="한국건강기능식품협회 기능성표시·광고심의">한국건강기능식품협회 기능성표시·광고심의</option>
          <option value="http://www.mfds.go.kr/" label="식품의약품안전처">식품의약품안전처</option>
          <option value="http://www.foodsafetykorea.go.kr/" label="식품안전정보포털">식품안전정보포털</option>
        </select>
        <a href="#none" @click="goSiteBtn" class="btn-go">GO</a>
      </div>
      <nav class="footer-menu">
        <router-link to="/intro/legal">이용안내</router-link>
        <router-link to="/intro/privacy"><strong>개인정보처리방침</strong></router-link>
        <router-link to="/intro/emailprivacy">이메일 무단수집 거부</router-link>
      </nav>
    </div>
    <div class="footer-info" :class="{ 'is-open': footerInfoOpen }">
      <button class="footer-info-toggle" type="button" :aria-expanded="footerInfoOpen ? 'true' : 'false'" @click="toggleFooterInfo">(사)한국건강기능식품협회 정보</button>
      <div class="footer-info-body">
        <address>
          <span>(사)한국건강기능식품협회</span>
          <span>13488 경기도 성남시 분당구 대왕판교로 700 B동 102호 (삼평동, 코리아바이오파크)</span>
          <br />
          <span>법인등록번호 115021-0001687</span>
          <span>사업자번호 114-82-07991</span>
          <span>대표자 정명수</span>
          <span>TEL 1661-2371</span>
          <span>FAX 0507-0317-4338</span>
          <span>통신판매번호 2026-성남분당A-0475</span>
        </address>
        <p>Copyrightⓒ 2022 Korea Health Functional Food Association, All rights reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteFooter",
  components: {},
  data: function () {
    return {
      relateSite: "",
      footerInfoOpen: true,
    };
  },
  mounted: function () {
    if (typeof window !== "undefined" && window.matchMedia) {
      this.footerInfoOpen = !window.matchMedia("(max-width: 768px)").matches;
    }
  },
  methods: {
    goSite: function (e) {
      if (this.relateSite == "") return;
      if (this.isApp()) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ action: "popup", url: this.relateSite }));
        return;
      }

      window.open(this.relateSite);
    },
    goSiteBtn: function (e) {
      this.goSite(e);
    },
    toggleFooterInfo: function () {
      this.footerInfoOpen = !this.footerInfoOpen;
    },
  },
};
</script>

<style scoped>
.footer-info-toggle {
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  background: transparent;
  border: 0;
  font-size: 12px;
  font-weight: 500;
  color: inherit;
  cursor: pointer;
}

.footer-info-toggle::after {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  margin-left: 8px;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(45deg);
  transition: transform 0.2s ease;
}

.footer-info-body {
  display: block;
}

@media (max-width: 768px) {
  .footer-info-toggle {
    display: inline-flex;
  }

  .footer-info-body {
    display: none;
  }

  .footer-info.is-open .footer-info-body {
    display: block;
  }

  .footer-info.is-open .footer-info-toggle::after {
    transform: translateY(1px) rotate(-135deg);
  }
}
</style>
